<template>
  <header id="header" :class="{ isScrolled }">
    <div class="container">
      <div>
        <h1 id="logo" :class="{ 'temp-logo': !!currentRouteType }">
          <router-link to="/" v-if="currentRouteType" class="temp-logo">한국잡월드 스마트 통합 예매</router-link>
          <a v-else href="/">한국잡월드 스마트 통합 예매</a>
        </h1>
        <div class="selMenu">
          <ul v-if="currentRouteType">
            <li :class="{ active: currentRouteType === 'ind' }"><a @click="() => indGrpRouteChange('ind')">개인</a></li>
            <li :class="{ active: currentRouteType === 'grp' }"><a @click="() => indGrpRouteChange('grp')">단체</a></li>
          </ul>
        </div>
      </div>
      <nav id="nav">
        <ul v-if="isLoggedIn">
          <!-- <li style="margin-right: 15px"><a>로그아웃</a></li> -->
          <li class="cart" style="margin-right: 15px">
            <router-link :to="'/' + (currentRouteType || 'ind') + '/cart'">체험바구니</router-link>
          </li>
          <li class="list">
            <router-link :to="'/' + (currentRouteType || 'ind') + '/reservations'">예약내역</router-link>
          </li>
        </ul>
        <ul v-else>
          <li class="login">
            <a :href="serverDomain + '/login.do?menuId=109'">로그인</a>
          </li>
          <li class="join">
            <a :href="serverDomain + '/registerStep0.do?mid=109&menuId=110'">회원가입</a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      isScrolled: false,
    };
  },
  computed: {
    ...mapState({ isLoggedIn: (state) => state.ui.isLoggedIn }),
  },
  methods: {
    scrollEvents: _.throttle(function () {
      this.isScrolled = document.documentElement.scrollTop > 25;
    }, 50),
    indGrpRouteChange(type) {
      const cRoute = this.$router.currentRoute;
      let targetRoute = '/' + type;
      if (cRoute.path === '/grp/reservations' || cRoute.path === '/ind/reservations') {
        targetRoute += '/reservations';
      }
      // if (cRoute.name === 'grp_cart' || cRoute.name === 'ind_cart') {
      //   targetRoute += '/cart';
      // }

      if (cRoute.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.scrollEvents);
  },
  unmounted() {
    window.removeEventListener('scroll', this.scrollEvents);
  },
};
</script>

<style lang="scss" scoped>
#header {
  position: sticky;
  top: -22px;
  background: #fff;
  transition: 0.2s;
  z-index: 10;

  &.isScrolled {
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.6);
  }

  .selMenu {
    & a {
      cursor: pointer;
    }
  }

  .temp-logo {
    width: 44px;
    a {
      background: url(@/assets/images/logo_icon.png) no-repeat left center;
      background-size: contain;
    }
  }
}
#header .container {
  position: sticky;
  top: 0;
}

@media (max-width: 540px) {
  #header .temp-logo {
    width: 35px;
  }
}
</style>
